import axios from "axios";

const API_URL = `${import.meta.env.VITE_API_URL}borrowing/materials`;

export default class StockOpnameService {
  static async getItems(page: number, search: string, room: string) {
    const res = await axios.get(`${API_URL}/items`, {
      params: { page, search, room },
      withCredentials: true,
    });
    return res.data.data;
  }

  static async getStudentRequestByBorrowing(borrowingId: string, accessToken: string) {
    const res = await axios.get(`${API_URL}/student/requests/by-borrowing/${borrowingId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      withCredentials: true,
    });
    return res.data.data;
  }

  static async getStaffRequestByBorrowing(borrowingId: string) {
    const res = await axios.get(`${API_URL}/staff/requests/by-borrowing/${borrowingId}`, {
      withCredentials: true,
    });
    return res.data.data;
  }

  static async getBatches(itemId: number, page: number, search: string) {
    const res = await axios.get(`${API_URL}/staff/items/${itemId}/batches`, {
      params: { page, q: search },
      withCredentials: true,
    });
    return res.data.data;
  }

  static async saveAllocations(payload: unknown) {
    const res = await axios.post(`${API_URL}/staff/requests/allocations`, payload, {
      withCredentials: true,
    });
    return res.data.data;
  }
}
